var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.81 6.307l3.212 3.195 3.169-3.129c.411-.409 1.09-.409 1.5 0 .412.41.412 1.084 0 1.493l-3.157 3.14 3.157 3.14c.412.409.412 1.083 0 1.492-.41.409-1.089.409-1.5 0l-3.158-3.14-3.213 3.195c-.41.41-1.089.41-1.5 0a1.057 1.057 0 010-1.492l3.213-3.196L6.309 7.8a1.057 1.057 0 010-1.492c.41-.41 1.089-.41 1.5 0z",
    fill: "#fff"
  })));
}
export default SvgError;